export const N27 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Sales by Channel Last Year vs Actual Sales",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Principal Code',
                        "columnName": 'DistributorCode',
                        "width": '140px',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Principal Name',
                        "columnName": 'DistributorName',
                        "width": '35%',
                        "align": "left",
                        "sortable": true,
                        "sum": false
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales(Value)',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales(Value)',
                        "width": '130px',
                        "align": "right",
                        "sortable": true,
                        "sum": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth(Value)',
                        "width": '130px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": 'DistributorName',
                "endpoint": "N27",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "DistributorCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "RegionCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "DistributorCode",
                        "selectedTitle": "Customer",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 2,
                                "visual": {
                                    "id": 1,
                                    "type": "advancedTable",
                                    "colorTheme": "colorTheme1",
                                    "title": "Customer",
                                    "binding": {
                                        "data": {
                                            "columns": [
                                                {
                                                    "name": 'Customer Name',
                                                    "columnName": 'CustomerName',
                                                    "width": '250px',
                                                    "align": "left",
                                                    "sortable": true,
                                                    "sum": false
                                                },
                                                {
                                                    "name": 'Actual Sales',
                                                    "columnName": 'ActualSales(Value)',
                                                    "width": '140px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'LY Sales',
                                                    "columnName": 'LYSales(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": true
                                                },
                                                {
                                                    "name": 'Growth %',
                                                    "columnName": 'Growth(Value)',
                                                    "width": '135px',
                                                    "align": "right",
                                                    "sortable": true,
                                                    "sum": false,
                                                    "percent": true
                                                }
                                            ],
                                            "title": 'CustomerName',
                                            "endpoint": "N27.1",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "2024" },
                                                { "key": "FromYear", "value": "1" },
                                                { "key": "ToMonth", "value": "2024" },
                                                { "key": "ToYear", "value": "1" },
                                                { "key": "DistributorCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" },
                                                { "key": "RegionCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "DistributorCustomerCode",
                                                    "selectedTitle": "Product",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 2,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": "colorTheme1",
                                                                "title": "Product",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Item Name',
                                                                                "columnName": 'ItemName',
                                                                                "width": '200px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales(Value)',
                                                                                "width": '140px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth(Value)',
                                                                                "width": '135px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": 'ItemName',
                                                                        "endpoint": "N27.2",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "2024" },
                                                                            { "key": "FromYear", "value": "1" },
                                                                            { "key": "ToMonth", "value": "2024" },
                                                                            { "key": "ToYear", "value": "1" },
                                                                            { "key": "DistributorCustomerCode", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" },
                                                                            { "key": "RegionCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {

                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}